// extracted by mini-css-extract-plugin
export default {"particles-container":"ParticlesBackground_particles-container__P0vE-"};